export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";

export const REGISTER_CONFIRM_REQUEST = "REGISTER_CONFIRM_REQUEST";
export const REGISTER_CONFIRM_SUCCESS = "REGISTER_CONFIRM_SUCCESS";
export const REGISTER_CONFIRM_ERROR = "REGISTER_CONFIRM_ERROR";

export const RECOVER_REQUEST = "RECOVER_REQUEST";
export const RECOVER_SUCCESS = "RECOVER_SUCCESS";
export const RECOVER_ERROR = "RECOVER_ERROR";